import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=470bacc6&scoped=true&"
import script from "./joinus.vue?vue&type=script&lang=js&"
export * from "./joinus.vue?vue&type=script&lang=js&"
import style0 from "./joinus.vue?vue&type=style&index=0&id=470bacc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bacc6",
  null
  
)

export default component.exports